import SortingVisualizer from './components/SortingVisualizer'
export default SortingVisualizer
